
$(document).on('ready', function(){
	$('.menu-toggle').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('closer');
		$('body').toggleClass('menu-open');
	});
	
	$('.caret').on('click', function(e){
		e.preventDefault();
		$(this).siblings('.sub-menu').slideToggle();
		$(this).toggleClass('rotate');
	});
	
	$('.overlay-toggle').on('click', function(e){
		e.preventDefault();
		ovSelector = $(this).attr('rel');
		ov = ovSelector ? $(ovSelector) : $(this).parents('.overlay');
		ov.toggleClass('active');
	});
	
	$('.profile-link').on('click', function(e){
		e.preventDefault();
		$(this).siblings('.overlay').toggleClass('active');
	});
	
	$('.overlay-closer').on('click', function(e){
		e.preventDefault();
		$(this).parents('.overlay').toggleClass('active');
	});
	
	$( '.gallery-grid .visual-link' ).swipebox();
	
	$('.homepage-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear',
		arrows:false,
		dots:false,
		autoplay: true,
		autoplaySpeed: 6000,
	});
	
	
	$('.page-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear',
		arrows:false,
		dots:true,
		autoplay: true,
		autoplaySpeed: 6000,
	});
	
	
	$('.stats-carousel').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		speed: 500,
		arrows:false,
		dots:false,
		autoplay: true,
		autoplaySpeed: 2000,
		responsive: [
			{
				breakpoint: 1024,
				settings: {slidesToShow: 3}
			},
			{
				breakpoint: 700,
				settings: {slidesToShow: 2}
			},
			{
				breakpoint: 550,
				settings: {slidesToShow: 1}
			},
		]
	});
	
	$('.caoursel-arrow').on('click', function(e){
		e.preventDefault();
		var dir = $(this).hasClass('prev') ? "slickPrev" : "slickNext";
		$('.stats-carousel').slick(dir);	
	});
	
});/*

GOOGLE MAPS
var apiKey = '';
var lat = 1;
var lng = 1; 
$(document).ready(function(){
	if ($('#map').length){
	 	// Asynchronously Load the map API 
    var script = document.createElement('script');
    script.src = "//maps.googleapis.com/maps/api/js?callback=initialize&key="+apiKey;
    document.body.appendChild(script);	
	}
});
		
function initialize() {
	var location = {lat: lat, lng:lng}
	var map;
	var mapOptions = {
		zoom:15,
		center: location,
		scrollwheel: false
	};
	
	map = new google.maps.Map(document.getElementById("map"), mapOptions);       
	var marker = new google.maps.Marker({
		position: location,
		map: map,
	});                

}

*/